import React from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from '../../components/Navbar'
import { useSelector } from 'react-redux'

function MainLayout() {
    const { theme } = useSelector((state) => state.theme)
    return (
        <div className='bg-body-tertiary vh-100 overflow-auto text-body' data-bs-theme={theme}>
            <Navbar />
            <Outlet />
        </div>
    )
}

export default MainLayout